import { useFragment, graphql } from 'react-relay';
import { FC, ReactElement, ComponentProps } from 'react';

// components
import { Button } from 'dibs-elements/exports/Button';
import { SharedContactDealerWrapper } from '../../contactDealer/SharedContactDealerWrapper';

// types
import { PdpSharedContactSellerButton_item$key as Item } from './__generated__/PdpSharedContactSellerButton_item.graphql';
import { PdpSharedContactSellerButton_user$key as User } from './__generated__/PdpSharedContactSellerButton_user.graphql';

const userFragment = graphql`
    fragment PdpSharedContactSellerButton_user on User {
        ...SharedContactDealerWrapper_user
    }
`;

const itemFragment = graphql`
    fragment PdpSharedContactSellerButton_item on Item {
        ...SharedContactDealerWrapper_item
    }
`;

type ButtonProps = ComponentProps<typeof Button>;

export const PdpSharedContactSellerButton: FC<{
    item: Item;
    dataTn?: string;
    currency: string;
    user: User | null | undefined;
    className?: string;
    fullWidth?: boolean;
    launchOrigin?: string;
    itemQuantity?: number;
    selectedSkuId?: string;
    children: ReactElement;
    size?: ButtonProps['size'];
    type?: ButtonProps['type'];
    modalType?:
        | 'REQUEST_PRICE'
        | 'REQUEST_IMAGES'
        | 'CONTACT_DEALER'
        | 'DESIGN_YOUR_OWN'
        | 'REQUEST_CUSTOMIZATION'
        | 'REQUEST_IMAGES_AND_VIDEOS';
}> = ({
    children,
    dataTn,
    type,
    size,
    launchOrigin,
    fullWidth,
    className,
    selectedSkuId,
    itemQuantity,
    currency,
    modalType,
    ...props
}) => {
    const user = useFragment(userFragment, props.user);
    const item = useFragment(itemFragment, props.item);

    return (
        <SharedContactDealerWrapper
            item={item}
            user={user}
            currency={currency}
            modalType={modalType}
            itemQuantity={itemQuantity}
            launchOrigin={launchOrigin}
            selectedSkuId={selectedSkuId}
        >
            {(onClick: $TSFixMe) => (
                <Button
                    fullWidth={fullWidth}
                    type={type}
                    size={size}
                    dataTn={dataTn}
                    onClick={onClick}
                    className={className}
                >
                    {children}
                </Button>
            )}
        </SharedContactDealerWrapper>
    );
};

// lazy load
export default PdpSharedContactSellerButton;
